import React from "react";
import TableCell from "@mui/material/TableCell";
import OverviewTable from "./OverviewTable";
import {Instrument} from "../../gen/api";
import MarkdownViewer from "../Markdown/MarkdownViewer";

type Props = {
  instrument: Instrument
  displayTitle?: boolean
}

export default function OverviewTableView({instrument, displayTitle = true}: Props) {
  return (
      <OverviewTable displayTitle={displayTitle}>
        <TableCell>
          <MarkdownViewer value={instrument.formOfSurvey}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.targetDimension}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.rater}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.ageRange}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.items}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.processingTime}/>
        </TableCell>
        <TableCell>
          <MarkdownViewer value={instrument.openAccess}/>
        </TableCell>
      </OverviewTable>
  );
}